import React from "react";
import FrontendImg from "assets/frontend-img.png";
import BackendImg from "assets/backend-img.png";
import { t } from "utils/i18n";

const WhatIDo = () => {
  return (
    <div className="todo-container">
      <h1>What I Do</h1>
      <section className="todo-cell-cover">
        <div className="cell">
          <img src={FrontendImg} alt="frontend-image" />
          <div>
            <h4>Web Frontend Development</h4>
            <p>{t("label.frontend.todo")}</p>
          </div>
        </div>
        <div className="cell">
          <img src={BackendImg} alt="backend-img" />
          <div>
            <h4>Backend Development</h4>
            <p>{t("label.backend.todo")}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhatIDo;
